import { FC } from 'react';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';
import {
  ManagementForms,
  fetchManagementRecord,
  fetchManagementUpdate,
  IManagement,
} from '../../../../features/management';
import { useEntityUpdate } from '../../../../features/entities/hooks';
import { PreloaderWrapper } from '../../../../components/preloader-wrapper';
import { PageTitle } from '../../../../components/page-title';
import { CabinetContainer } from '../../../../components/cabinet-container';
import { ROUTE_MANAGEMENT } from '../../../../common/constants';
import { get } from '../../../../common/utils';

export const ManagementUpdatePage: FC = () => {
  const { t } = useTranslation();
  const { isFetching, isUpdating, data, handleValid } = useEntityUpdate<IManagement>({
    entity: 'management',
    recordThunk: fetchManagementRecord,
    updateThunk: fetchManagementUpdate,
    nextPath: ROUTE_MANAGEMENT,
  });

  const defaultValues = { ...data };

  return (
    <>
      <Helmet>
        <title>{t('management.update')}</title>
      </Helmet>
      <CabinetContainer>
        <PageTitle title={t('management.update.title')} mb={3} />
        <PreloaderWrapper isLoading={isFetching}>
          <ManagementForms
            onValid={handleValid}
            defaultValues={defaultValues}
            isLoading={isUpdating}
            key={get(data, 'id')}
          />
        </PreloaderWrapper>
      </CabinetContainer>
    </>
  );
};
